import React, { useState, useEffect } from "react";
import { withTranslation, Trans } from "react-i18next";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import BusinessIcon from "@material-ui/icons/Business";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Badge from "@material-ui/core/Badge";
import MailIcon from "@material-ui/icons/Mail";
import BlockIcon from "@material-ui/icons/Block";
import InfoIcon from "@material-ui/icons/Info";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import HourglassFullIcon from "@material-ui/icons/HourglassFull";
import DescriptionIcon from "@material-ui/icons/Description";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from '@material-ui/icons/Cancel';
import PermScanWifiIcon from '@material-ui/icons/PermScanWifi';
import { green , amber, grey} from '@material-ui/core/colors';

//import "../../assets/css/customstyles.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "36ch",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
}));

 function ServicesList(props) {
  const classes = useStyles();
  let history = useHistory();
  const { templateID } = props;
  let colorStyles = templateID == 2 ? { color: props.componentbgcolor } : {};
  // let [icon] = useState('')
  function handleClick() {
    history.push({
      pathname: "/layout/SurveyCasePreview",
      state: props.caseobj,
    });
  }

  let icon = <HourglassEmptyIcon />;
  if (props.casetype) {
    switch (props.casetype) {
      case "open":
        icon = <HourglassEmptyIcon style={{ color: amber[500] }} />;
        break;
      case "resolved":
        icon = <CheckCircleIcon style={{ color: green[500] }} />;
        break;
      case "declined":
          icon = <CancelIcon color="secondary" />;
          break;
      default:
        break;
    }
  }

  function formatTime(timestamp) {
    const d = new Date(timestamp);
    const time = `${d.getDate()}/${
      d.getMonth() + 1
    }/${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}`;
    return time;
  }

  return (
    <Grid
      container
      spacing={3}
      className="gridcontainer chatuserlistdiv borderbottomgrey"
      onClick={handleClick}
    >
      <Grid item xs={2} className="zero">
        <p className="zero  text-center responselisticon">
          <LockOpenIcon  style={colorStyles}/>
        </p>
      </Grid>
      <Grid item xs={2} className="zero">
        <p className="zero  text-center responselisticon" style={colorStyles}>
        {props.caseobj.caseSetSurveyId}
        </p>
      </Grid>
      <Grid item xs={7} className="zero">
        <p className="zero  chatusername" style={colorStyles}>
          {props.caseobj.surveyName}
        </p>
        <p className="zero color-yellow chatdistance">

          {props.caseobj.offlineDate == undefined? formatTime(props.caseobj.createdAt) : props.caseobj.offlineDate}
        </p>
      </Grid>
      {
        props.caseobj.offlineDate != undefined ? 
        (
          <>
          <Grid item xs={2} className="zero">
          <p className="text-center unreadmsgicon reportmiddle">
            <span className="color-green display-flex"><PermScanWifiIcon></PermScanWifiIcon></span>
          </p>
          <span class="case-status-label">offline</span>
        </Grid>
        </>
        ):
        ('')
      }
    </Grid>
  );
}

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : state.storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};



const transServicesList = withTranslation()(ServicesList);
export default connect(mapStateToProps, {})(transServicesList);
